<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses" />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      vueAppClasses: [],
    };
  },
  created() {},
  watch: {},
  methods: {
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
  },
};
</script>

<style>
#app {
  font-family: var(--ctint-font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>
